function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module list/listediting
 */
import ListCommand from './listcommand';
import IndentCommand from './indentcommand';
import { Plugin } from 'ckeditor5/src/core';
import { Enter } from 'ckeditor5/src/enter';
import { Delete } from 'ckeditor5/src/typing';
import { cleanList, cleanListItem, modelViewInsertion, modelViewChangeType, modelViewMergeAfterChangeType, modelViewMergeAfter, modelViewRemove, modelViewSplitOnInsert, modelViewChangeIndent, modelChangePostFixer, modelIndentPasteFixer, viewModelConverter, modelToViewPosition, viewToModelPosition } from './converters';
/**
 * The engine of the list feature. It handles creating, editing and removing lists and list items.
 *
 * It registers the `'numberedList'`, `'bulletedList'`, `'indentList'` and `'outdentList'` commands.
 *
 * @extends module:core/plugin~Plugin
 */

var ListEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(ListEditing, _Plugin);

  var _super = _createSuper(ListEditing);

  function ListEditing() {
    _classCallCheck(this, ListEditing);

    return _super.apply(this, arguments);
  }

  _createClass(ListEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var editor = this.editor; // Schema.
      // Note: in case `$block` will ever be allowed in `listItem`, keep in mind that this feature
      // uses `Selection#getSelectedBlocks()` without any additional processing to obtain all selected list items.
      // If there are blocks allowed inside list item, algorithms using `getSelectedBlocks()` will have to be modified.

      editor.model.schema.register('listItem', {
        inheritAllFrom: '$block',
        allowAttributes: ['listType', 'listIndent']
      }); // Converters.

      var data = editor.data;
      var editing = editor.editing;
      editor.model.document.registerPostFixer(function (writer) {
        return modelChangePostFixer(editor.model, writer);
      });
      editing.mapper.registerViewToModelLength('li', getViewListItemLength);
      data.mapper.registerViewToModelLength('li', getViewListItemLength);
      editing.mapper.on('modelToViewPosition', modelToViewPosition(editing.view));
      editing.mapper.on('viewToModelPosition', viewToModelPosition(editor.model));
      data.mapper.on('modelToViewPosition', modelToViewPosition(editing.view));
      editor.conversion.for('editingDowncast').add(function (dispatcher) {
        dispatcher.on('insert', modelViewSplitOnInsert, {
          priority: 'high'
        });
        dispatcher.on('insert:listItem', modelViewInsertion(editor.model));
        dispatcher.on('attribute:listType:listItem', modelViewChangeType, {
          priority: 'high'
        });
        dispatcher.on('attribute:listType:listItem', modelViewMergeAfterChangeType, {
          priority: 'low'
        });
        dispatcher.on('attribute:listIndent:listItem', modelViewChangeIndent(editor.model));
        dispatcher.on('remove:listItem', modelViewRemove(editor.model));
        dispatcher.on('remove', modelViewMergeAfter, {
          priority: 'low'
        });
      });
      editor.conversion.for('dataDowncast').add(function (dispatcher) {
        dispatcher.on('insert', modelViewSplitOnInsert, {
          priority: 'high'
        });
        dispatcher.on('insert:listItem', modelViewInsertion(editor.model));
      });
      editor.conversion.for('upcast').add(function (dispatcher) {
        dispatcher.on('element:ul', cleanList, {
          priority: 'high'
        });
        dispatcher.on('element:ol', cleanList, {
          priority: 'high'
        });
        dispatcher.on('element:li', cleanListItem, {
          priority: 'high'
        });
        dispatcher.on('element:li', viewModelConverter);
      }); // Fix indentation of pasted items.

      editor.model.on('insertContent', modelIndentPasteFixer, {
        priority: 'high'
      }); // Register commands for numbered and bulleted list.

      editor.commands.add('numberedList', new ListCommand(editor, 'numbered'));
      editor.commands.add('bulletedList', new ListCommand(editor, 'bulleted')); // Register commands for indenting.

      editor.commands.add('indentList', new IndentCommand(editor, 'forward'));
      editor.commands.add('outdentList', new IndentCommand(editor, 'backward'));
      var viewDocument = editing.view.document; // Overwrite default Enter key behavior.
      // If Enter key is pressed with selection collapsed in empty list item, outdent it instead of breaking it.

      this.listenTo(viewDocument, 'enter', function (evt, data) {
        var doc = _this.editor.model.document;
        var positionParent = doc.selection.getLastPosition().parent;

        if (doc.selection.isCollapsed && positionParent.name == 'listItem' && positionParent.isEmpty) {
          _this.editor.execute('outdentList');

          data.preventDefault();
          evt.stop();
        }
      }, {
        context: 'li'
      }); // Overwrite default Backspace key behavior.
      // If Backspace key is pressed with selection collapsed on first position in first list item, outdent it. #83

      this.listenTo(viewDocument, 'delete', function (evt, data) {
        // Check conditions from those that require less computations like those immediately available.
        if (data.direction !== 'backward') {
          return;
        }

        var selection = _this.editor.model.document.selection;

        if (!selection.isCollapsed) {
          return;
        }

        var firstPosition = selection.getFirstPosition();

        if (!firstPosition.isAtStart) {
          return;
        }

        var positionParent = firstPosition.parent;

        if (positionParent.name !== 'listItem') {
          return;
        }

        var previousIsAListItem = positionParent.previousSibling && positionParent.previousSibling.name === 'listItem';

        if (previousIsAListItem) {
          return;
        }

        _this.editor.execute('outdentList');

        data.preventDefault();
        evt.stop();
      }, {
        context: 'li'
      });

      var getCommandExecuter = function getCommandExecuter(commandName) {
        return function (data, cancel) {
          var command = _this.editor.commands.get(commandName);

          if (command.isEnabled) {
            _this.editor.execute(commandName);

            cancel();
          }
        };
      };

      editor.keystrokes.set('Tab', getCommandExecuter('indentList'));
      editor.keystrokes.set('Shift+Tab', getCommandExecuter('outdentList'));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "afterInit",
    value: function afterInit() {
      var commands = this.editor.commands;
      var indent = commands.get('indent');
      var outdent = commands.get('outdent');

      if (indent) {
        indent.registerChildCommand(commands.get('indentList'));
      }

      if (outdent) {
        outdent.registerChildCommand(commands.get('outdentList'));
      }
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'ListEditing';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [Enter, Delete];
    }
  }]);

  return ListEditing;
}(Plugin);

export { ListEditing as default };

function getViewListItemLength(element) {
  var length = 1;

  var _iterator = _createForOfIteratorHelper(element.getChildren()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;

      if (child.name == 'ul' || child.name == 'ol') {
        var _iterator2 = _createForOfIteratorHelper(child.getChildren()),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            length += getViewListItemLength(item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return length;
}